module.exports = __webpack_public_path__ + "img/weibo.b21ef2ee.png";